// extracted by mini-css-extract-plugin
var _1 = "lAMJl";
var _2 = "LVkPL";
var _3 = "tJztU";
var _4 = "lls2e";
var _5 = "yEnTv";
var _6 = "EmjaJ";
export { _1 as "arrow", _2 as "content", _3 as "tooltip", _4 as "variant-default", _5 as "variant-error", _6 as "variant-warning" }
